// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const primarina: PokeData = {
  "id": 730,
  "name": "primarina",
  "height": 18,
  "weight": 440,
  "base_experience": 239,
  "types": [
    PokeType.WATER,
    PokeType.FAIRY
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "growl",
    "sing",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "icy-wind",
    "encore",
    "hyper-voice",
    "captivate",
    "aqua-jet",
    "disarming-voice",
    "misty-terrain",
    "moonblast",
    "baby-doll-eyes",
    "sparkling-aria"
  ],
  "moves": [
    "growl",
    "hydro-pump",
    "bubble-beam",
    "hyper-voice",
    "aqua-jet",
    "misty-terrain",
    "moonblast",
    "rain-dance",
    "aqua-cutter",
    "aqua-tail",
    "spirit-break",
    "life-dew",
    "heal-bell"
  ],
  "evolution_chain": {
    "id": 376,
    "item": null,
    "species": [
      {
        "name": "popplio",
        "order": 728,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "brionne",
        "order": 729,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 728,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "primarina",
        "order": 730,
        "types": [
          PokeType.WATER,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 729,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 128,
    "speed": 88,
    "ability_power": 184
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
